import { createAction, handleActions } from 'redux-actions';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import * as authAPI from '../lib/api/auth';
import createRequestSaga, {
    createRequestActionTypes
} from "../lib/createRequestSaga";

const TEMP_SET_USER = 'user/TEMP_SET_USER';
const SET_CORPR = 'user/SET_CORPR';
const SET_USER = 'user/SET_USER';
const svySttDt = 'user/svySttDt';
const SVY_END_DT = 'user/SVY_END_DT';
const SET_EXTERNAL_IP = 'user/SET_EXTERNAL_IP';
const SET_IS_LOAD_TEMP_DATA = 'user/SET_IS_LOAD_TEMP_DATA';
const [CHECK, CHECK_SUCCESS, CHECK_FAILURE] = createRequestActionTypes('user/CHECK');
const [CORPR, CORPR_SUCCESS, CORPR_FAILURE] = createRequestActionTypes('user/CORPR');
const [CODE, CODE_SUCCESS, CODE_FAILURE] = createRequestActionTypes('user/GET_CODE');

export const tempSetUser = createAction(TEMP_SET_USER, user => user);
export const setSvyStartDt = createAction(svySttDt, user => user);
export const setSvyEndDt = createAction(SVY_END_DT, user => user);
export const setExternalIp = createAction(SET_EXTERNAL_IP, ip => ip);
export const setIsLoadTempData = createAction(SET_IS_LOAD_TEMP_DATA, flag => flag);
export const check = createAction(CHECK);
export const getCorprName = createAction(CORPR, ({stdYear, corprInfoDiviNo}) => ({stdYear, corprInfoDiviNo}));
export const getCommCode = createAction(CODE, groupCode => groupCode);

export const setCorprInfo = createAction(SET_CORPR, corpr => corpr);
export const setUserInfo = createAction(SET_USER, user => user);


const checkSaga = createRequestSaga(CHECK, authAPI.check);
const corprSaga = createRequestSaga(CORPR, authAPI.getCorprName);
const codeSaga = createRequestSaga(CODE, authAPI.getCommCode);

function checkFailureSaga() {
    try {
        localStorage.removeItem('user');
    } catch (e) {
        console.log('localStorage is not working');
    }
}

export function* userSaga() {
    yield takeLatest(CHECK, checkSaga);
    yield takeLatest(CHECK_FAILURE, checkFailureSaga);
    yield takeLatest(CORPR, corprSaga);
    yield takeEvery(CODE, codeSaga);
}

const initialState = {
    user: null,
    corpr: null,
    code: null,
    checkError: null,
    svyStartDt: null,
    corprInfo: null,
    userInfo: null,
    ip: null,
    isLoadTempData: false
};

export default handleActions(
    {
        [TEMP_SET_USER]: (state, {payload: user}) => ({
            ...state,
            stdYear: user.stdYear
        }),
        [SET_CORPR]: (state, {payload: corpr}) => ({
            ...state,
            corprInfo: {
                // userName: corpr.userName,
                corprInfoDiviNo: corpr.corprInfoDiviNo,
                corprName: corpr.corprName,
                email: corpr.email,
                koFileAttchYn: corpr.koFileAttchYn
            },
        }),
        [SET_USER]: (state, {payload: user}) => {
            return {
            ...state,
            userInfo: {
                stdYear: user.stdYear,
                // corprCode: user.corprCode,
                corprInfoDiviNo: user.corprInfoDiviNo,
                // userAdmnDiviNo: user.userAdmnDiviNo,
                empNo: user.empNo,
                // username: user.username,
                // surveyYn: user.surveyYn,
                openYn: user.openYn,
                // citOpenYn: user.citOpenYn,
                // teqOpenYn: user.teqOpenYn
            },
        }},
        [svySttDt]: (state, action) => ({
            ...state,
            svyStartDt: action.payload
        }),
        [SVY_END_DT]: (state, action) => ({
            ...state,
            svyEndDt: action.payload
        }),
        [CHECK_SUCCESS]: (state, {payload: user}) => ({
            ...state,
            user,
            checkError: null
        }),
        [CHECK_FAILURE]: (state, {payload: error}) => ({
            ...state,
            user: null,
            checkError: error
        }),
        [CORPR_SUCCESS]: (state, {payload: corpr}) => ({
            ...state,
            user: {
                userName: corpr.CORPR.username,
                corprInfoDiviNo: corpr.CORPR.corprno,
                corprName: corpr.CORPR.corprname,
                email: corpr.CORPR.email,
                koFileAttchYn: corpr.CORPR.kofileattchyn
            },
            'CO034': corpr.CO034,
            'HC028': corpr.HC028,
            'YA011': corpr.YA011,
            checkError: null
        }),
        [CORPR_FAILURE]: (state, {payload: error}) => ({
            ...state,
            corprBaseInfo: null,
            checkError: error
        }),
        [CODE_SUCCESS]: (state, {payload: code}) => ({
            ...state,
            [code[0].COMM_GROP_CODE]: code
        }),
        [CODE_FAILURE]: (state, {payload: error}) => ({
            ...state,
            commCode: null
        }),
        [SET_EXTERNAL_IP]: (state, action) => ({
            ...state,
            ip: action.payload
        }),
        [SET_IS_LOAD_TEMP_DATA]: (state, action) => ({
            ...state,
            isLoadTempData: action.payload
        }),
    },
    initialState
);
